<script>
  import { onMount } from "svelte";

  import Filter from "../Filter/Filter.svelte";
  import { getOrderFilters, ORDER_FILTER_TYPE } from "../Filter/static";
  import { DAY } from "../Common/tools";
  import BasicFilter from "./BasicFilter.svelte";
  import Stats from "./Stats/Stats.svelte";
  import {External, M} from "../external";

  let filterInstance;
  let now = new Date();
  let filters = [];
  let instance = null;
  let activeFunnelId = null;
  let activePeriod = {
    label: M.LAST_SEVEN_DAYS,
    id: "7-days",
    from: new Date(now.getTime() - 6 * DAY),
    to: now
  };

  let disabledCrmProperties = [-1, -2, "utm_source", "utm_campaign", "utm_medium", "utm_content", "utm_term"];

  let orderFilters = getOrderFilters([
    ORDER_FILTER_TYPE.NAME,
    ORDER_FILTER_TYPE.EMAIL,
    //ORDER_FILTER_TYPE.CREATED,
    ORDER_FILTER_TYPE.TOTAL,
    ORDER_FILTER_TYPE.PRODUCT,
    //ORDER_FILTER_TYPE.FUNNEL,
    ORDER_FILTER_TYPE.STATUS,
    ORDER_FILTER_TYPE.PAID,
    ORDER_FILTER_TYPE.UTM_SOURCE,
    ORDER_FILTER_TYPE.UTM_CAMPAIGN,
    ORDER_FILTER_TYPE.UTM_MEDIUM,
    ORDER_FILTER_TYPE.UTM_CONTENT,
    ORDER_FILTER_TYPE.UTM_TERM
  ]);

  let onFilterChange = () => {
    setTimeout(() => {
      instance.reload();
    }, 1);
  };

  let onBasicFilterChange = (event) => {
    activePeriod = event.detail.period;
    activeFunnelId = event.detail.funnel.id;
    onFilterChange();
  };

  let filterSources = (event) => {
    let source = event.detail.source;

    if (filters.length === 0) {
      filters.push([]);
    }

    let sourceFound = false;
    filters.forEach((filterRow) => {
      if (sourceFound) {
        return;
      }
      filterRow.forEach((filter) => {
        if (!sourceFound && filter.type === External.CRM_FILTER_TYPE.ORDER_PROPERTY && filter.id === ORDER_FILTER_TYPE.UTM_SOURCE && filter.func === "is" && filter.value !== source) {
          sourceFound = true;
          filter.value = source;
        }
      });
    });

    if (!sourceFound) {
      filters[0].push({
        func: "is",
        type: External.CRM_FILTER_TYPE.ORDER_PROPERTY,
        id: ORDER_FILTER_TYPE.UTM_SOURCE,
        value: source
      });
    }
    filterInstance.onFilterChanged();
  };
</script>

<div class="account-settings store-products">
  <div class="inner-wrapper members-table-wrapper">
    <div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 15px;">
      <div class="top-background">
        <div class="top-background filter-wrapper-outer f-left">
          <Filter
            enableOR={false}
            bind:this={filterInstance}
            bind:filters
            enableSaveSegment={false}
            onChange={onFilterChange}
            disabledCrmProperties={disabledCrmProperties}
            customFilters={orderFilters} />
        </div>
        <div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
          <h1 class="members-title f-left t-center" style="margin-bottom: 0;">{M.STORE_DASHBOARD}</h1>
          <BasicFilter on:change={(event) => onBasicFilterChange(event)} period={activePeriod} />
        </div>
      </div>
    </div>

    <div class="content-wrapper members-content-wrapper">
      <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;">
        <Stats bind:this={instance} filters={filters} period={activePeriod} funnelId={activeFunnelId} on:filtersources={filterSources} />
      </div>
    </div>
  </div>
</div>
